import { type FC } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { type UiHStackProps } from '@/lib/ui';
import WorkshopTicketPageForm from './WorkshopTicketPageForm';
import PageRow from './PageRow';

export interface ManageLabelsProps extends UiHStackProps {
}

const WorkshopTicketPage: FC<ManageLabelsProps> = ({ ...props }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <PageRow
        title={'Workshop tickets page'}
        description={'Manage labels and descriptions on the page where we list the workshop tickets.'}
        onEdit={onToggle}
        {...props}
      />
      <WorkshopTicketPageForm
        onSaveSuccess={() => {}}
        isVisible={isOpen}
        onClose={onToggle}
      />
    </>
  );
};

export default WorkshopTicketPage;
